<template>
  <transition name="modal-fade">
    <div v-if="showDialog" class="modal-base">
      <div class="modal-base__backdrop" />
      <div
        :id="id"
        class="modal-base__dialog text-size-14"
        :style="cssStyle + style"
      >
        <div v-if="title" 
        :class="titleCss"
        class="modal-base__header  text-h6">
          <p class="mb-0">{{ title }}</p>

          <font-awesome-icon
            v-if="showCancelIcon"
            class="ml-1 cur-pointer"
            @click="cancelModel"
            :icon="['fal', 'times']"
          />
        </div>
        <div class="modal-base__body">
          <slot />
          <slot name="buttons">
            <div
              v-if="displayCancelButton || displayOkButton"
              class="modal-base__footer text-center"
            >
              <BtnLink
                v-if="displayCancelButton"
                @click.native="cancelModel"
                :label="labelCancel"
              />

              <Btn
                v-if="displayOkButton"
                :loading="loading"
                @click.native="okModal"
                :label="labelOk"
              />
            </div>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalDialog',
  props: {
    id: {
      type: String,
    },

    title: {
      type: String,
    },

    titleCss: {
        type: String,
    },

    labelCancel: {
      type: String,
    },
    labelOk: {
      type: String,
    },
    width: {
      type: String,
    },
    showCancelIcon: {
      type: Boolean,
      default: false,
    },
    displayCancelButton: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    displayOkButton: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: Number,
      default: 470,
    },

    dlgStyle: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      posX: 150,
      posY: 0,
      showDialog: false,
    };
  },
  computed: {
    style() {
      if (this.dlgStyle != null) {
        return this.dlgStyle;
      }

      return 'margin:' + this.posX + 'px auto';
    },

    cssStyle() {
      if (this.mobileView) return '90%';
      if (this.width) {
        const width = this.width;
        return `width:${width}px;`;
      }
      return 'max-width:' + this.maxWidth + 'px;';
    },
  },

  methods: {
    openModal(event=null) {
      if (event) {
        this.posX = event.clientX;
        this.posY = event.clientY;
      }

      this.showDialog = true;
    },

    closeModal() {
      //console.info("Modal Dialog - close Modal");
      this.showDialog = false;
    },


    cancelModel() {
      this.$emit('cancel');
    },

    okModal() {
      //console.info("Modal Dialog - ok Modal");      
      this.$emit('ok');
    }
  },

  updated() {
    // if( !this.id ) return;
    // const dlg = document.getElementById(this.id);
    // if( dlg )
    // console.error('modal dialog height update:', dlg.clientHeight);
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.modal-base {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  color: $dark-grey;
  &__backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  &__dialog {
    background-color: #ffffff;
    border: 1px solid $mid-grey;
    -webkit-transform: translate3d(0, 0, 0);
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    z-index: 2;
    max-width: 600px;
    @media screen and (max-width: 767px) {
      width: 90%;
    }
  }
  &__close {
    width: 30px;
    height: 30px;
  }
  &__header {
    padding: 20px 20px 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 20px;
    border-bottom: 1px solid #d9d9d9;
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }
  &__body {
    padding: 10px 20px 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  &__footer {
    margin: 10px;
    margin-top: 0px;
    padding-top: 10px;
    border-top: 0px solid $light-grey;
  }
}

.modal-fade-enter-active {
  transition: opacity 0.5s;
}

.modal-fade-leave-active {
  transition: opacity 0.5s;
}

.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter {
  opacity: 0;
}

.modal-fade-enter-to {
}
</style>